import dayjs from "dayjs";

export function tooltipFormatter(value: string) {
  if (value) {
    try {
      return dayjs(value, "YYYY-MM").format("MMM YYYY");
    } catch (e) {
      console.error("Error formatting date:", e);
    }
    return value;
  }
  return "";
}
